/**
 * 上传相关
 */
import axios from "../../utils/axios";

// 七牛云上传文件
export function qiniuUpload(formdata) {
    return axios({
        url: "/qiniu/upload",
        method: "post",
        data: formdata
    });
}

//判断图片是否有效
export function isExist(query) {
    return axios({
        url: "/qiniu/isExist",
        method: "get",
        params: query
    });
}

// 获取七牛上传 upToken
export function qiuNiuUpToken(query) {
    return axios({
        url: "/qiniu/getToken",
        method: "get",
        params: query
    });
}

// 七牛云上传文件
export function uploadFile(formdata) {
    return axios({
        url: "http://upload-z1.qiniup.com/",
        method: "post",
        data: formdata
    });
}

//上传文件upload
export function upload(data, config) {
    return axios({
        url: "/upload/tool/uploadpro",
        method: "post",
        data: data,
        headers: config
    });
}
